export default function(instance){
    return{
        Commit(payload){
            return instance.put("/CompanyUserPeriodPlan/Commit", payload);
        },
    }
}
